import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { MutateDeliveryProviderConfigurationDrawer } from "./MutateDeliveryProviderConfigurationDrawer";

type Props = {
  existingDeliveryProviders?: string[];
};

export const MutateDeliveryProviderConfigurationSelector = ({
  existingDeliveryProviders,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary onClick={() => setModalOpen(true)} type="button">
        Create delivery provider configuration
      </ButtonPrimary>
      <MutateDeliveryProviderConfigurationDrawer
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        existingDeliveryProviders={existingDeliveryProviders}
      />
    </div>
  );
};
